import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';

const ShortCloseApprovalSection = ({ item, isVendor, loggedInUserEmail,
     handleReject, handleApprove, canEdit }) => {
    if (!item?.shortCloseInitiatedDetails) return null;

    const { remarks, reason, otherReason, approvers } = item.shortCloseInitiatedDetails;

    return (
        <>
            {item?.shortCloseInitiatedDetails && (
                <div
                className={`short-close-grid-row ${item?.isShortClosed ? 'short-closed' : ''}`}
                >
                    <div
                        className="two-column-grid text-gray-300 grid grid-cols-3 gap-6 p-4 rounded-md content-start"
                    >
                        <div>
                            <p className="font-muli">Remarks</p>
                            <p className="font-muli font-bold opacity-80 break-all">{remarks || '-'}</p>
                        </div>
                        <div>
                            <p className="font-muli">Reason for Short Close</p>
                            <div className="flex items-center gap-1 relative group">
                                <div className="font-muli font-bold opacity-80">{reason}</div>
                                {reason === 'Other' && (
                                    <div className="relative group inline-block">
                                      <FaInfoCircle className="text-xs opacity-80 cursor-pointer text-[#565FBB] z-50" color="#565FBB" />
                                        <div className="backdrop opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200" />
                                        <div
                                            className="shortclose-tooltip"
                                        >
                                            <div className="absolute -bottom-1 right-1/2 transform -translate-x-1/2 w-3 h-3 bg-white rotate-45 border-gray-300" />
                                            {otherReason}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="border-l-2 border-gray-100 text-gray-300 grid grid-cols-2 gap-6 p-4 break-words content-start">
                        <ul>
                            {approvers?.filter(({ approver }) => {
                                if (!isVendor) return true;
                                return approver?.email === loggedInUserEmail;
                            })?.map((approver) => (
                                <li
                                    key={approver?.approver?.id}
                                    className="flex items-center gap-2 text-[12px] whitespace-nowrap"
                                >
                                    <div className="flex items-center gap-1 relative">
                                        <div className="flex items-center gap-2">
                                            <span className="flex items-center justify-center">
                                                {approver.status === 'Approved' && (
                                                    <i className="approved-text fa fa-check-circle" aria-hidden="true" />
                                                )}
                                                {approver.status === 'Pending' && (
                                                    <i className="pending-text fa fa-check-circle" aria-hidden="true" />
                                                )}
                                                {approver.status === 'Rejected' && (
                                                    <i className="rejected-text fa fa-times-circle-o" aria-hidden="true" />
                                                )}
                                            </span>

                                            <span className="flex items-center gap-1">
                                                <span>
                                                    Level
                                                    {' '}
                                                    <span className="font-bold">
                                                        {approver.level}
                                                    </span>
                                                    {' '}
                                                    -
                                                    {' '}
                                                </span>

                                                <span className="font-bold">
                                                    {approver.status}
                                                </span>

                                                <span className="opacity-60" title={approver?.approver?.email}>
                                                   (
                                                    <span className="email-ellipsis opacity-60 cursor-pointer">
                                                      {approver?.approver?.email}
                                                    </span>
                                                   )
                                                </span>
                                            </span>
                                        </div>
                                        {approver?.approverRemarks && (
                                            <div className="relative group inline-block">
                                            <FaInfoCircle className="text-xs opacity-80 cursor-pointer text-[#565FBB] z-50" color="#565FBB" />
                                                <div className="backdrop opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200" />
                                                <div
                                                    className="approver-tool-tip approver-remark-tooltip-box"
                                                >
                                                    <div className="approvel-popup-position absolute -bottom-1 transform w-3 h-3 bg-white rotate-45" />
                                                    {approver?.approverRemarks}
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}

            {canEdit && item?.approveRejectButtonVisible && (
                <div
                    className="bg-light-blue items-center rounded-t-md flex flex-row justify-between p-2 pb-4 max-w-[50px]"
                >
                    <div />
                    <div className="flex gap-2">
                        <button
                            type="button"
                            className="btn-reject text-sm font-semibold uppercase cursor-pointer"
                            onClick={() => handleReject(item)}
                        >
                            Reject
                        </button>
                        <button
                            type="button"
                            className="btn-approve text-sm font-semibold uppercase cursor-pointer"
                            onClick={() => handleApprove(item)}
                        >
                            Approve
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ShortCloseApprovalSection;
